
import css from 'styled-jsx/css';

export default css.global`/* @styled-jsx=global */

.cta-button {
  @include button-legacy;
  position: relative;

  svg {
    margin-left: 8px;
    vertical-align: middle;
    margin-top: -2px;
  }

  &.cta-button--unstyled {
    display: inline-block;
    border-radius: none;
    padding: 0;
    -webkit-text-decoration: none;
    text-decoration: none;
    text-align: unset;
    transition: unset;
    cursor: pointer;
    background-color: unset;
    border: none;
    color: unset;
  }
}
`